import { __assign } from 'tslib';
import * as React from 'react';
import { testPageUrl } from '../../../../utils/constants/urls.esm.js';
import { cleanConceptPrefix } from '../../../../utils/stringFormatting.esm.js';
import ReflexTestsStaticItem from './ReflexTestsStaticItem.esm.js';
import styles from './ReflexTestsStaticList.module.esm.js';

var ReflexTestsStaticList = function (_a) {
    var condition = _a.condition, tests = _a.tests;
    if (!(tests === null || tests === void 0 ? void 0 : tests.length))
        return null;
    return (React.createElement("div", { className: styles.root, "data-testid": "reflex-tests-static-list" },
        React.createElement("div", null, "Reflex to additional tests".concat(condition ? " (".concat(condition.toLowerCase(), ")") : '', ":")),
        React.createElement("div", { className: styles.testList }, tests === null || tests === void 0 ? void 0 : tests.map(function (test, index) {
            var _a;
            var testUrl = "".concat(testPageUrl).concat(cleanConceptPrefix(test.code));
            return (React.createElement(React.Fragment, { key: "".concat(test.code, "_").concat(index) },
                React.createElement(ReflexTestsStaticItem, __assign({ item: test }, (test.code && { url: testUrl }))), (_a = test === null || test === void 0 ? void 0 : test.addOns) === null || _a === void 0 ? void 0 :
                _a.map(function (addOn) { return (React.createElement(ReflexTestsStaticItem, __assign({ isAddon: true, item: addOn, key: addOn.code }, (test.code && { url: testUrl })))); })));
        }))));
};

export { ReflexTestsStaticList as default };
//# sourceMappingURL=ReflexTestsStaticList.esm.js.map
